import React from 'react'

export default function BreadcrumbSeparator({
	separator,
}: {
	separator: string
}) {
	return <div>{separator}</div>
}
